import { magicDisable, magicEnable } from "./helpers"
import { themeName } from "./liquidInit"

const themeHasMultipleInputContainers = ["Debut"].includes(themeName)
const minusButtonSelector = "[data-fsa-minus-cart]"
const visibleInputSelector = "[data-fsa-input-cart]"
const plusButtonSelector = "[data-fsa-plus-cart]"
const hiddenQuantitySelector = "[data-fsa-hidden-quantity-cart]"
const containerVariantIdSelector = (variantId) =>
  `[data-fsa-product-variant-id="${variantId}"]`

const getDataFrom = (container) => ({
  step: parseInt(container.dataset.fsaStep, 10),
  minimum: parseInt(container.dataset.fsaMin, 10),
  multiplier: parseInt(container.dataset.fsaMultiplier, 10),
  currentQuantity: parseInt(container.dataset.fsaCurrentQuantity, 10),
  shopifyMaximumQuantity: parseInt(container.dataset.fsaShopifyMax, 10),
  key: container.dataset.fsaCartItemKey,
  variantId: container.dataset.fsaCartVariantId,
  maximum: parseInt(container.dataset.fsaMax, 10),
  cartQuantity: parseInt(container.dataset.fsaCartQuantity, 10),
})

const getMinusPlusElementsFrom = (container) => ({
  minusButton: container.querySelector(minusButtonSelector),
  plusButton: container.querySelector(plusButtonSelector),
})

const getAllElementsFrom = (container) => ({
  minusButton: container.querySelector(minusButtonSelector),
  visibleInput: container.querySelector(visibleInputSelector),
  plusButton: container.querySelector(plusButtonSelector),
  hiddenQuantity: container.querySelector(hiddenQuantitySelector),
})

const getInputElementsFrom = (container) => ({
  visibleInput: container.querySelector(visibleInputSelector),
  hiddenQuantity: container.querySelector(hiddenQuantitySelector),
})

const setContainerData = (container, data) => {
  const { key, cartQuantity, currentQuantity } = data

  const { multiplier } = getDataFrom(container)

  const { visibleInput, hiddenQuantity } = getInputElementsFrom(container)

  // Round value to nearest valid fraction
  const newValue = currentQuantity / multiplier

  if (key != null) {
    container.dataset.fsaCartItemKey = key
  }

  if (cartQuantity != null) {
    container.dataset.fsaCartQuantity = cartQuantity
  }

  if (currentQuantity != null) {
    container.dataset.fsaCurrentQuantity = currentQuantity
    if (
      currentQuantity % multiplier === 0 &&
      currentQuantity > 0 &&
      multiplier > 1
    ) {
      visibleInput.value = newValue.toFixed(1)
    } else {
      visibleInput.value = newValue
    }

    if (hiddenQuantity != null) {
      hiddenQuantity.value = currentQuantity
      // hiddenQuantity.dispatchEvent(new Event("change"))
    }
  }
}

const updateContainer = (container, newQuantity) => {
  const { key } = getDataFrom(container)

  if (themeHasMultipleInputContainers) {
    const containers = document.querySelectorAll(
      `[data-fsa-cart-item-key="${key}"]`
    )
    containers.forEach((inputContainer) => {
      setContainerData(inputContainer, {
        key,
        currentQuantity: newQuantity,
      })
    })
  } else {
    setContainerData(container, {
      key,
      currentQuantity: newQuantity,
    })
  }
}

const minus = (container) => {
  const {
    step,
    minimum,
    currentQuantity,
    shopifyMaximumQuantity,
  } = getDataFrom(container)

  const { minusButton, plusButton } = getMinusPlusElementsFrom(container)

  // Set Next Value
  let newQuantity = currentQuantity - step

  if (newQuantity < minimum) {
    newQuantity = 0
  }

  updateContainer(container, newQuantity)

  if (newQuantity < shopifyMaximumQuantity && plusButton.disabled) {
    magicEnable(plusButton)
  }

  if (newQuantity <= 0 && !minusButton.disabled) {
    magicDisable(minusButton)
  }
}

const plus = (container) => {
  const {
    step,
    minimum,
    currentQuantity,
    shopifyMaximumQuantity,
  } = getDataFrom(container)

  const { minusButton, plusButton } = getMinusPlusElementsFrom(container)

  let newQuantity = currentQuantity + step

  if (newQuantity < minimum) {
    newQuantity = minimum
  }

  updateContainer(container, newQuantity)

  if (newQuantity > 0 && minusButton.disabled) {
    magicEnable(minusButton)
  }

  if (newQuantity >= shopifyMaximumQuantity && !plusButton.disabled) {
    magicDisable(plusButton)
  }
}

const type = (container) => {
  const {
    step,
    minimum,
    multiplier,
    currentQuantity,
    shopifyMaximumQuantity,
  } = getDataFrom(container)

  const { visibleInput, minusButton, plusButton } = getAllElementsFrom(
    container
  )

  // Set to Current Value until action
  let newQuantity = currentQuantity

  const inputQuantity = parseFloat(visibleInput.value) * multiplier

  if (Number.isNaN(inputQuantity)) {
    console.warn("Input Is NOT a Number")
    newQuantity = currentQuantity
    updateContainer(container, newQuantity)
  } else {
    // Set Input Value
    newQuantity = inputQuantity

    if (newQuantity > shopifyMaximumQuantity) {
      newQuantity = shopifyMaximumQuantity
    }

    if (newQuantity <= 0) {
      newQuantity = 0
    }

    if (newQuantity > 0 && newQuantity < minimum) {
      newQuantity = minimum
    }

    if (newQuantity % step !== 0) {
      newQuantity = Math.round(newQuantity).toFixed(2)
    }

    updateContainer(container, newQuantity)

    if (newQuantity <= 0) {
      magicDisable(minusButton)
    } else {
      magicEnable(minusButton)
    }

    if (newQuantity < shopifyMaximumQuantity) {
      magicEnable(plusButton)
    } else {
      magicDisable(plusButton)
    }
  }
}

const updateContainerWithItem = (container, item) => {
  const { key, shopifyMaximumQuantity } = getDataFrom(container)

  const { plusButton, minusButton } = getMinusPlusElementsFrom(container)

  const previousKey = key
  const newKey = item.key

  const newCartQuantity = parseInt(item.quantity, 10)

  if (themeHasMultipleInputContainers) {
    const containers = document.querySelectorAll(
      `[data-fsa-cart-item-key="${previousKey}"]`
    )
    containers.forEach((inputContainer) => {
      setContainerData(inputContainer, {
        key: newKey,
        cartQuantity: newCartQuantity,
        currentQuantity: newCartQuantity,
      })
    })
  } else {
    setContainerData(container, {
      key: newKey,
      cartQuantity: newCartQuantity,
      currentQuantity: newCartQuantity,
    })
  }

  if (minusButton.disabled) {
    magicEnable(minusButton)
  }

  if (newCartQuantity >= shopifyMaximumQuantity) {
    magicDisable(plusButton)
  } else {
    magicEnable(plusButton)
  }
}

const updateAfterLocalStorageChange = (cart) => {
  console.warn("[Update Cart Item Containers]")
  cart.items.forEach((item) => {
    const containers = document.querySelectorAll(
      `[data-fsa-cart-variant-id="${item.variant_id}"]`
    )
    if (containers) {
      containers.forEach((container) => {
        updateContainerWithItem(container, item)
      })
    }
  })
}

export default {
  updateAfterLocalStorageChange,
  getDataFrom,
  containerVariantIdSelector,
  minusButtonSelector,
  visibleInputSelector,
  plusButtonSelector,
  hiddenQuantitySelector,
  minus,
  plus,
  type,
}
